import gql from "graphql-tag";

export const ParentSite = {
    QUERY: {
        GETPARENTSITES: gql`
            query getParentSites($page: Int!, $limit: Int!) {
                GetManyParentSite(page: $page, limit: $limit) {
                    message
                    docs {
                        id
                        email
                        tel_number
                        name
                        created_at
                    }
                    page
                    totalPages
                    totalDocs
                    prevPage
                    nextPage
                    limit
                }
            }
        `,
        GETSITEPARENT: gql`
            query GetData($id: ID!, $site: String!) {
                GetSiteParent(id: $id) {
                    message
                    doc {
                        id
                        name
                        email
                        tel_number
                        created_at
                        sites {
                            id
                            name
                            logo
                            address
                            email
                            website
                            tel
                            created_at
                            type {
                                id
                                name
                                created_at
                            }
                        }
                    }
                }
                GetAllSiteType(id: $site) {
                    message
                    docs {
                        id
                        name
                    }
                }
            }
        `,
    },
    MUTATION: {
        //   Create New Parent Site
        NEWPARENTSITE: gql`
            mutation newSite($name: String!, $email: String!, $tel: String!) {
                CreateParentSite(name: $name, email: $email, tel: $tel) {
                    message
                    doc {
                        id
                        name
                        email
                        tel_number
                        created_at
                    }
                }
            }
        `,

        // Update Parent Site

        UPDATEPARENTSITE: gql`
            mutation updateSite($id: ID!, $model: UpdateParentInput!) {
                UpdateParentSite(id: $id, model: $model) {
                    message
                    doc {
                        id
                        name
                        email
                        tel_number
                        created_at
                    }
                }
            }
        `,

        // Creates New Site Under Parent-Site

        CREATENEWSITE: gql`
            mutation CreateNewSite($model: NewSiteInput!, $id: ID!) {
                NewSite(model: $model, id: $id) {
                    message
                    doc {
                        id
                        name
                        logo
                        address
                        email
                        tel
                        website
                        type {
                            id
                            name
                        }
                        created_at
                    }
                }
            }
        `,
        UPDATESITE: gql`
            mutation UpdateSite($id: ID!, $update: NewSiteInput!) {
                UpdateSite(id: $id, update: $update) {
                    message
                    doc {
                        id
                        name
                        logo
                        address
                        email
                        website
                        tel
                        type {
                            id
                            name
                        }
                        created_at
                        parent {
                            id
                            name
                            email
                            tel_number
                        }
                    }
                }
            }
        `,
    },
};
